import { Component } from '@angular/core';
import { IntroFourComponent } from './intro-four.component';

@Component({
  selector: 'eid-intro-four-desktop',
  templateUrl: './intro-four.desktop.component.html',
  styleUrls: ['./intro-four.desktop.component.scss']
})
export class IntroFourDesktopComponent extends IntroFourComponent {}
